/**
 * Nudge a numeric slider value by one step, clamped to [min, max].
 * Rounds to the step's decimal precision so repeated clicks stay on the grid.
 */
export function stepBoundedValue(value, step, direction, min, max) {
  const current = Number(value);
  const increment = Number(step);
  const lo = Number(min);
  const hi = Number(max);
  if (!Number.isFinite(current) || !Number.isFinite(increment) || increment <= 0) {
    return current;
  }

  const delta = direction < 0 ? -increment : increment;
  const decimals = (String(increment).split('.')[1] || '').length;
  const rounded = Number((current + delta).toFixed(decimals));

  if (Number.isFinite(lo) && rounded < lo) {
    return lo;
  }
  if (Number.isFinite(hi) && rounded > hi) {
    return hi;
  }
  return rounded;
}
